import React, { useState, useEffect } from "react";
import { Helmet } from "react-helmet";
import PropTypes from "prop-types";
import { makeStyles } from "@mui/styles";
// import { withStyles } from "@mui/styles";
import {
  Box,
  Button,
  Container,
  CardContent,
  Divider,
  Card,
  Link,
  CardHeader,
  Grid,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TableContainer,
  Collapse,
  TextField,
  Tooltip
} from "@mui/material";
import PerfectScrollbar from "react-perfect-scrollbar";
import Typography from "@mui/material/Typography";
import Popover from "@mui/material/Popover";
// import SearchField from "react-search-field";
// import { Tab, Tabs } from "@mui/material";
import Paper from "@mui/material/Paper";
import DeleteIcon from "@mui/icons-material/Delete";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import CardHeader1 from "./LabHeader";
import { CopyToClipboard } from "react-copy-to-clipboard";
import IconButton from "@mui/material/IconButton";
import FileCopyOutlinedIcon from "@mui/icons-material/FileCopyOutlined";
import StartLab from "./Actions/ManualStartLab";
import StopLab from "./Actions/ManualStopLab";
import Refresh from "./Actions/Reload";
import ReportEX from "./ManualReportExport";
import ActiveLog from "./ActiveLog";
import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import { KeyboardArrowDown, KeyboardArrowUp } from '@mui/icons-material';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';

import PlayArrowTwoToneIcon from "@mui/icons-material/PlayArrowTwoTone";
import StopTwoToneIcon from "@mui/icons-material/StopTwoTone";
import moment from "moment";
// import LabReport from "./LabReport";
import Log from "./Logs/ManualLog";
import GuacConnect from "./GuacConnect";
import { styled } from '@mui/material/styles';
import CloseIcon from '@mui/icons-material/Close';
import RefreshIcon from '@mui/icons-material/Refresh';
// import OverallLabReport from "./OverallLabReport";
import NotToDo from "./Actions/NotToDo";

const dialogWidth = '1100px';
const dialogHeight = '97vh';

const CustomDialog = styled(Dialog)(({ theme }) => ({
  '& .MuiDialog-paper': {
    width: dialogWidth,
    height: dialogHeight, // Use full viewport height
    maxWidth: 'none',
    margin: 0,
    padding: theme.spacing(2),
    overflow: 'hidden', // Ensure no overflow on the dialog itself
    display: 'flex', // Flexbox to manage layout
    flexDirection: 'column',
  },
  '& .MuiDialogContent-root': {
    padding: 0,
    flexGrow: 1, // Take remaining space
    overflow: 'auto', // Enable scrolling on the content area
  },
  '& .MuiDialogActions-root': {
    justifyContent: 'flex-end',
  },
}));


const ensureAbsoluteUrl = (url) => {
  if (!url) return '#'; // Fallback in case URL is null or undefined
  if (!url.startsWith('http://') && !url.startsWith('https://')) {
    return `http://${url}`;
  }
  return url;
};

const options = [{ id: 1, name: "Trainee", value: "name" }];

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`vertical-tabpanel-${index}`}
      aria-labelledby={`vertical-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box p={3}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

function a11yProps(index) {
  return {
    id: `vertical-tab-${index}`,
    "aria-controls": `vertical-tabpanel-${index}`,
  };
}

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    backgroundColor: "#b5b6b7",
    display: "flex",
    height: 280,
  },
  tabs: {
    borderRight: `1px solid`,
    overflow: `visible`,
  },
  title: {
    fontSize: 14,
  },
}));

const ManualDetails = () => {
  const classes = useStyles();
  const [expandedRow, setExpandedRow] = useState(null);

  const handleExpandRow = (rowName) => {
    if (rowName === expandedRow) {
      setExpandedRow(null);
    } else {
      setExpandedRow(rowName);
    }
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const [value, setValue] = React.useState("");


  const handleChange = (event) => {
    setValue(parseInt(event.target.value));
  };

  const [showInstancePassword, setShowInstancePassword] = useState(false);
  const [showAppPasswords, setShowAppPasswords] = useState(false);

  const handleInstancePasswordIconClick = () => {
    setShowInstancePassword(!showInstancePassword);
  };

  const handleAppPasswordIconClick = () => {
    setShowAppPasswords(!showAppPasswords);
  };


  function DateTime1(startDate) {
    const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    const startDate1 = new Date(startDate).toLocaleString("en-GB", {
      timeZone: `${timezone}`,
    });
    const startDate2 = startDate1.split(",");
    const startDatef = startDate2[0].replace("/", "-");
    const startDate3 = startDatef.replace("/", "-");

    return startDate3;
  }

  function DateTime2(endDate, endTime) {
    const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    const endDate1 = new Date(endDate + "T" + endTime + ":00.000Z").toLocaleString("en-GB", { timeZone: `${timezone}` });
    const endDate2 = endDate1.split(",");
    const endDatef = endDate2[0].replace("/", "-");
    const endDate3 = endDatef.replace("/", "-");
    return endDate3;
  }

  function DateTime3(startDate, startTime) {
    const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;

    const startTime1 = new Date(
      startDate + "T" + startTime + ":00.000Z"
    ).toLocaleString("en-GB", { timeZone: `${timezone}` });
    const startTime2 = startTime1.split(",");
    const startTime3 = startTime2[1].substring(0, 6);
    return startTime3;
  }

  function DateTime4(endDate, endTime) {
    const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    const endTime1 = new Date(
      endDate + "T" + endTime + ":00.000Z"
    ).toLocaleString("en-GB", { timeZone: `${timezone}` });
    const endTime2 = endTime1.split(",");
    const endTime3 = endTime2[1].substring(0, 6);
    return endTime3;
  }

  function timeDiff(endDate, endTime) {
    const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    const endTime1 = new Date(
      endDate + "T" + endTime + ":00.000Z"
    ).toLocaleString("en-GB", { timeZone: `${timezone}` });
    const endTime2 = endTime1.split(",");
    const endTime3 = endTime2[1].substring(0, 6);
    // const currentTime = moment();
    // const formattedTime = currentTime.format('HH:mm');
    const currentTime = new Date().toLocaleString('en-GB', { timeZone: `${timezone}` });
    const currentTime1 = currentTime.split(",");
    const formattedTime = currentTime1[1].substring(0, 6);
    const endTimeMoment = moment(endTime3, 'HH:mm');
    const formattedTimeMoment = moment(formattedTime, 'HH:mm');
    // const formattedTimeMoment = moment("12:45", 'HH:mm');

    const diffInMinutes = endTimeMoment.diff(formattedTimeMoment, 'minutes');
    const disableButton = diffInMinutes <= `${process.env.REACT_APP_DIFFENDTIME}` && diffInMinutes >= 0;
    return disableButton;
  }

  const [instancelist, setinstancelist] = useState([]);
  useEffect(() => {
    const InstanceID = localStorage.getItem("InstanceID");
    fetch(
      `${process.env.REACT_APP_API_URL}/api/manuallabcustomized/${InstanceID}/admin`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
      }
    )
      .then((resp) => resp.json())
      .then((data) => {
        if (data.detail) {
        } else {
          setinstancelist(data);
        }
      })
      .catch((error) => {
        console.error(error);
      });
  }, []);



  const [hvmreportdataset, setHvmreportdataset] = useState([]);

  useEffect(() => {
   
    const InstanceID = localStorage.getItem("InstanceID");
    fetch(`${process.env.REACT_APP_API_URL}/api/manuallabreport/${InstanceID}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + localStorage.getItem("token"),
      },
    })
      .then((resp) => resp.json())
      .then((data) => {
        setHvmreportdataset(data);
      })
      .catch((error) => {
        console.error(error);
      });
  }, []);

  const [openLog, setOpenLog] = React.useState(false);

  const handleClickOpenLog = () => {
    setOpenLog(true);
  };

  const handleCloseLog = () => {
    setOpenLog(false);
  };

  const handleLogOk = () => {
    setOpenLog(false);
  };

  const [opendelete, setOpendelete] = React.useState(false);

  const handleClickOpenDelete = () => {
    setOpendelete(true);
  };

  const handleCloseDelete = () => {
    setOpendelete(false);
  };

  useEffect(() => {
    setExpandedRow("");
  }, [value])

  const Delete = () => {
    return function () {
      window.location.href = "/app/instance/manual";
      const InstanceID = localStorage.getItem("InstanceID");
      let trigger = "application"
      fetch(
        `${process.env.REACT_APP_API_URL}/api/manualdeletelab/${InstanceID}/${trigger}`,
        {
          method: "DELETE",
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + localStorage.getItem("token"),
          },
        }
      )
        .then((response) => response.json())
        .then((data) => {
          handleCloseDelete();
        })
        .catch((error) => {
          handleCloseDelete();
        });
      handleCloseDelete();
    };
  };

  const [anchorEl, setAnchorEl] = React.useState(null);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const open1 = Boolean(anchorEl);

  const id = open1 ? "simple-popover" : undefined;

  const [selectedIndex, setSelectedIndex] = React.useState(0);
  const handleMenuItemClick = (event, index) => {
    setSelectedIndex(index);
  };

  const [searchitems, setSearchItems] = React.useState(0);
  const [copied, setCopied] = React.useState(false);

  const [openDialog, setOpenDialog] = useState(false);
  const [guacData, setGuacData] = useState([]);
  const [refreshConnection, setRefreshConnection] = useState(false);

  // const handleConnectClick = (details) => {
  //   setGuacData(details);
  //   setOpenDialog(true);
  // };

  const handleCloseDialog = () => {
    setOpenDialog(false);
  };

  const handleRefreshConnection = () => {
    setRefreshConnection(true);
  };

  // console.log("guacData", guacData);
  // console.log("instancelist", instancelist);

  // const handleConnectClick = (details) => {
  //   setGuacData(details);
  //   localStorage.setItem('guacData', JSON.stringify(details));
  //   window.open('guacconnect', '_blank');
  // };

  // const handleConnectClick = (details) => {
  //   const url = new URL(window.location.href);
  //   url.pathname = "/guacconnect";
  //   url.searchParams.set("details", JSON.stringify(details));
  //   window.open(url.toString(), "_blank");
  // };


  return (
    <>
      {instancelist.map((instancelist) => (
        <React.Fragment>
          <Helmet>
            <title>LabAsService</title>
          </Helmet>
          <Box
            sx={{
              backgroundColor: "background.default",
              minHeight: "100%",
              py: 3,
            }}
          >
            <div
              style={{ alignItems: "center", display: "flex", width: "600px" }}
            >
              <CustomDialog
                open={openDialog}
                onClose={handleCloseDialog}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
              >
                <DialogTitle style={{ marginTop: "-30px", display: 'flex', justifyContent: 'space-between', alignItems: 'center' }} id="alert-dialog-title">
                  Guacamole Display - Machine Name : {guacData.name}
                  <div>
                    <IconButton
                      aria-label="refresh"
                      onClick={handleRefreshConnection}
                      style={{ color: 'blue' }}
                    >
                      <RefreshIcon />
                    </IconButton>
                    <IconButton
                      aria-label="close"
                      onClick={handleCloseDialog}
                      style={{ color: 'red' }}
                    >
                      <CloseIcon />
                    </IconButton>
                  </div>
                </DialogTitle>
                <DialogContent style={{ marginTop: "-20px" }}>
                  <GuacConnect
                    details={guacData}
                    width={dialogWidth}
                    height={dialogHeight}
                    refreshConnection={refreshConnection}
                    disableCopyPaste={instancelist.disable_copypaste_guac}
                    onRefreshComplete={() => setRefreshConnection(false)}
                  />
                </DialogContent>
              </CustomDialog>
              <Dialog
                open={opendelete}
                onClose={handleCloseDelete}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
              >
                <DialogTitle id="alert-dialog-title">
                  Are you sure you want to delete the Lab{" "}
                  <strong style={{ color: "#EF5350" }}>
                    {instancelist.name}
                  </strong>{" "}
                  ?
                </DialogTitle>
                <DialogContent>
                  <DialogContentText id="alert-dialog-description"></DialogContentText>
                </DialogContent>
                <DialogActions>
                  <Button onClick={handleCloseDelete} color="primary">
                    Disagree
                  </Button>
                  <Button onClick={Delete()} color="primary" autoFocus>
                    Agree
                  </Button>
                </DialogActions>
              </Dialog>
              {/* <Dialog
                open={openLog}
                onClose={handleCloseLog}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
              >
                <DialogTitle id="alert-dialog-title">
                  Activity Log
                </DialogTitle>
                <DialogContent>
                  <DialogContentText id="alert-dialog-description">
                    Hello
                  </DialogContentText>
                </DialogContent>
                <DialogActions>
                  <Button onClick={handleLogOk} color="primary" autoFocus>
                    OK
                  </Button>
                </DialogActions>
              </Dialog> */}
            </div>
            <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
              <NotToDo/>
              <Refresh />
              {/* <OverallLabReport />
              <LabReport
              // name={details.name}
              // index_name={details.tag}
              // analytics_panel_id={details.analytics_panel_id}
              /> */}
              {instancelist.status === "Stopped" ? (
                <StartLab endDate={`${instancelist.end_date}`} endTime={`${instancelist.stop_time}`} />
              ) : instancelist.status === "Running" ? (
                <React.Fragment>
                  <ReportEX pccreportdataset={hvmreportdataset} />
                  <StopLab endDate={`${instancelist.end_date}`} endTime={`${instancelist.stop_time}`} />
                </React.Fragment>
              ) : instancelist.status === "Stop Initiated" ? (
                <Tooltip title="Stop Initiated" arrow>
                <Button
                  sx={{
                    mx: 1,
                    width: '150px',
                    height: '30px',
                    marginRight: "30px",
                    marginBottom: "20px",
                    marginTop: "-15px",
                    borderRadius: '50px',
                    boxShadow: '0 2px 4px rgba(0,0,0,0.2)',
                    p: 0, 
                  }}
                  style={{ whiteSpace: 'nowrap' }}
                  variant="outlined"
                  color="primary"
                  startIcon={<StopTwoToneIcon />}
                  disabled={timeDiff(`${instancelist.end_date}`, `${instancelist.stop_time}`)}
                >
                  Stop Initiated
                </Button>
                </Tooltip>
              ) : instancelist.status === "Start Initiated" ? (
                <Tooltip title="Start Initiated" arrow>
                <Button
                  sx={{
                    mx: 1,
                    width: '150px',
                    height: '30px',
                    marginRight: "30px",
                    marginBottom: "20px",
                    marginTop: "-15px", 
                    borderRadius: '50px',
                    boxShadow: '0 2px 4px rgba(0,0,0,0.2)',
                    p: 0, 
                  }}
                  style={{ whiteSpace: 'nowrap' }}
                  variant="outlined"
                  color="primary"
                  startIcon={<PlayArrowTwoToneIcon />}
                  disabled={timeDiff(`${instancelist.end_date}`, `${instancelist.stop_time}`)}
                >
                  Start Initiated
                </Button>
                </Tooltip>
              ) : instancelist.status === "Stopping" ? (
                <Tooltip title="stopping" arrow>
                  <span style={{ display: 'inline-flex' }}>
                    <IconButton
                      sx={{
                        mx: 1,
                        width: { xs: '26px', sm: '30px' },
                        height: { xs: '26px', sm: '30px' },
                        minWidth: 'auto',
                        marginRight: "30px",
                        marginBottom: "20px",
                        marginTop: "-15px",
                        borderRadius: '8px',
                        boxShadow: '0 2px 4px rgba(0,0,0,0.2)',
                        p: 0,
                      }}
                      color="primary"
                      disabled={timeDiff(`${instancelist.end_date}`, `${instancelist.stop_time}`)}
                      aria-label="stopping"
                    >
                      <StopTwoToneIcon sx={{ fontSize: { xs: '1rem', sm: '1.1rem' } }} />
                    </IconButton>
                  </span>
                </Tooltip>
              ) : instancelist.status === "Starting" ? (
                <Tooltip title="Starting" arrow>
                <Button
                  sx={{
                    mx: 1,
                    width: '150px',
                    height: '30px',
                    marginRight: "30px",
                    marginBottom: "20px",
                    marginTop: "-15px",
                    borderRadius: '50px',
                    boxShadow: '0 2px 4px rgba(0,0,0,0.2)',
                    p: 0, 
                  }}
                  style={{ whiteSpace: 'nowrap' }}
                  variant="outlined"
                  color="primary"
                  startIcon={<PlayArrowTwoToneIcon />}
                  disabled={timeDiff(`${instancelist.end_date}`, `${instancelist.stop_time}`)}
                >
                  Starting
                </Button>
                </Tooltip>
              ) : (
                ""
              )}
              <Tooltip title="Delete" arrow>
                <Button
                  sx={{
                    mx: 1,
                    height: { xs: "26px", sm: "30px" },
                    width: { xs: "26px", sm: "30px" },
                    minWidth: 'auto',
                    marginRight: "30px",
                    marginBottom: "20px",
                    marginTop: "-15px",
                    borderRadius: "50px",
                    boxShadow: '0 2px 4px rgba(0,0,0,0.2)',
                    p: 0,
                  }}
                  variant="contained"
                  color="secondary"
                  onClick={handleClickOpenDelete}
                  disabled={
                    !(
                      instancelist.status === "Running" ||
                      instancelist.status === "Stopped" ||
                      instancelist.status === "failed_con_update"
                    ) ||
                    timeDiff(`${instancelist.end_date}`, `${instancelist.stop_time}`)
                  }
                  aria-label="delete"
                >
                  <DeleteIcon sx={{ fontSize: { xs: '1rem', sm: '1.1rem' } }} />
                </Button>
              </Tooltip>
            </Box>
            
            <Container maxWidth={false}>
              <Box border={0} sx={{ mt: 0 }}>
                <Card>
                  <CardContent>
                    <Box
                      sx={{
                        background: 'linear-gradient(90deg, rgb(6, 57, 108), rgb(6, 57, 108))',
                        borderRadius: '8px',
                        px: 2,
                        py: 0.75, // ↓ reduced vertical padding for smaller height
                        mb: 2,
                        boxShadow: 2,
                      }}
                    >
                      <Typography
                        color="white"
                        display="inline-block"
                        gutterBottom
                        variant="h6"
                        sx={{
                          lineHeight: 1.1,
                          fontWeight: 500, // reduced from 'bold' (700) → medium weight
                        }}
                        
                      >
                        Lab Name: {instancelist.name}
                      </Typography>
                    </Box>
                    <div>
                      <TableContainer component={Paper}>
                        <Table size="small" aria-label="simple table">
                          <TableBody>
                            <TableRow key="name">
                              <TableCell
                                align="left"
                                component="th"
                                scope="row"
                              >
                                <Typography
                                  variant="h6"
                                  fontWeight="fontWeightBold"
                                  style={{ display: "inline-block" }}
                                  gutterBottom
                                >
                                  CodeShare : <Tooltip title="Open CodeShare" arrow>
                                    <Button size="small" style={{ height: "25px" }} variant="outlined" target="_blank" endIcon={<OpenInNewIcon style={{ height: "15px" }} />} href={instancelist.codeshare}>
                                      Open
                                    </Button>
                                  </Tooltip>
                                  <CopyToClipboard
                                    text={instancelist.codeshare}
                                    onCopy={() => setCopied(true)}
                                  >
                                    <IconButton
                                      aria-label="Filter"
                                      color="primary"
                                      onClick={handleClick}
                                      style={{ height: "25px" }}
                                    >
                                      <FileCopyOutlinedIcon style={{ height: "20px" }} />
                                    </IconButton>
                                  </CopyToClipboard>
                                  <Popover
                                    id={id}
                                    open={open1}
                                    anchorEl={anchorEl}
                                    onClose={handleClose}
                                    anchorOrigin={{
                                      vertical: "bottom",
                                      horizontal: "center",
                                    }}
                                    transformOrigin={{
                                      vertical: "top",
                                      horizontal: "center",
                                    }}
                                  >
                                    <Typography
                                      style={{
                                        color: "forestgreen",
                                      }}
                                    >
                                      Copied!.
                                    </Typography>
                                  </Popover>
                                </Typography>
                              </TableCell>
                              <TableCell align="left">
                                <Typography
                                  variant="h6"
                                  fontWeight="fontWeightBold"
                                  style={{
                                    display: "inline-block",
                                  }}
                                  gutterBottom
                                >
                                  Status : <span style={{ fontWeight: "normal" }}>{instancelist.status}</span>
                                </Typography>
                              </TableCell>
                              <TableCell align="left">
                                <Typography
                                  variant="h6"
                                  fontWeight="fontWeightBold"
                                  style={{ display: "inline-block" }}
                                  gutterBottom
                                >
                                  Number of Trainees : <span style={{ fontWeight: "normal" }}>{instancelist.no_of_trainee}</span>
                                </Typography>
                              </TableCell>
                              <TableCell align="left">
                                <Typography
                                  variant="h6"
                                  fontWeight="fontWeightBold"
                                  style={{ display: "inline-block" }}
                                  gutterBottom
                                >Number of Machines : <span style={{ fontWeight: "normal" }}>{`${instancelist.machine_count}`}</span> </Typography>
                              </TableCell>
                            </TableRow>
                            <TableRow key="name">
                              
                              <TableCell align="left">
                                <Typography
                                  variant="h6"
                                  fontWeight="fontWeightBold"
                                  style={{ display: "inline-block" }}
                                  gutterBottom
                                >
                                  Start Date : <span style={{ fontWeight: "normal" }}>{DateTime1(`${instancelist.start_date}`)}</span>
                                </Typography>
                              </TableCell>
                              {instancelist.start_time == "" ||
                                instancelist.start_time == null ? (
                                <TableCell align="left">
                                  <Typography
                                    variant="h6"
                                    fontWeight="fontWeightBold"
                                    style={{ display: "inline-block" }}
                                    gutterBottom
                                  >
                                    Start Time : <span style={{ fontWeight: "normal" }}>NA</span>
                                  </Typography>
                                </TableCell>
                              ) : (
                                <TableCell align="left">
                                  <Typography
                                    variant="h6"
                                    fontWeight="fontWeightBold"
                                    style={{ display: "inline-block" }}
                                    gutterBottom
                                  >
                                    Start Time : <span style={{ fontWeight: "normal" }}>{DateTime3(`${instancelist.start_date}`, `${instancelist.start_time}`)}</span>
                                  </Typography>
                                </TableCell>
                              )}
                              <TableCell align="left">
                                <Typography
                                  variant="h6"
                                  fontWeight="fontWeightBold"
                                  style={{ display: "inline-block" }}
                                  gutterBottom
                                >
                                  End Date : <span style={{ fontWeight: "normal" }}>{DateTime2(`${instancelist.end_date}`, `${instancelist.stop_time}`)}</span>
                                </Typography>
                              </TableCell>

                              {instancelist.stop_time == "" ||
                                instancelist.stop_time == null ? (
                                <TableCell align="left">
                                  <Typography
                                    variant="h6"
                                    fontWeight="fontWeightBold"
                                    style={{ display: "inline-block" }}
                                    gutterBottom
                                  >
                                    Stop Time : <span style={{ fontWeight: "normal" }}>NA</span>
                                  </Typography>
                                </TableCell>
                              ) : (
                                <TableCell align="left">
                                  <Typography
                                    variant="h6"
                                    fontWeight="fontWeightBold"
                                    style={{ display: "inline-block" }}
                                    gutterBottom
                                  >
                                    End Time : <span style={{ fontWeight: "normal" }}>{DateTime4(`${instancelist.end_date}`, `${instancelist.stop_time}`)}</span>
                                  </Typography>
                                </TableCell>
                              )}
                            </TableRow>
                            <TableRow key="meetingurl">
                              <TableCell align="left" component="th" scope="row">
                                <Typography
                                  variant="h6"
                                  fontWeight="fontWeightBold"
                                  style={{ display: "inline-block" }}
                                  gutterBottom
                                >
                                  Schedule : <span style={{ fontWeight: "normal" }}>{instancelist.depends_on}</span>
                                </Typography>
                              </TableCell>
                              <TableCell >
                                <Typography
                                  variant="h6"
                                  fontWeight="fontWeightBold"
                                  style={{ display: "inline-block" }}
                                  gutterBottom
                                >
                                  Meeting Link:
                                  <a
                                    href={ensureAbsoluteUrl(instancelist.meeting_url)}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    style={{ textDecoration: 'underline', color: 'blue', marginLeft: '10px' }}
                                  >
                                    {instancelist.meeting_url}
                                  </a>
                                  <CopyToClipboard
                                    text={instancelist.meeting_url}
                                    onCopy={() => setCopied(true)}
                                  >
                                    <IconButton
                                      aria-label="Filter"
                                      color="primary"
                                      onClick={handleClick}
                                      style={{ height: "25px" }}
                                    >
                                      <FileCopyOutlinedIcon style={{ height: "20px" }} />
                                    </IconButton>
                                  </CopyToClipboard>
                                  <Popover
                                    id={id}
                                    open={open1}
                                    anchorEl={anchorEl}
                                    onClose={handleClose}
                                    anchorOrigin={{
                                      vertical: "bottom",
                                      horizontal: "center",
                                    }}
                                    transformOrigin={{
                                      vertical: "top",
                                      horizontal: "center",
                                    }}
                                  >
                                    <Typography style={{ color: "forestgreen" }}>
                                      Copied!.
                                    </Typography>
                                  </Popover>
                                </Typography>
                              </TableCell>
                            </TableRow>
                          </TableBody>
                        </Table>
                      </TableContainer>
                    </div>
                  </CardContent>
                </Card>
              </Box>
              <Divider />
              <Box border={0} sx={{ mt: 1 }} paddingBottom={0} paddingTop={0}>
                <Card>
                  <Typography
                    color="textPrimary"
                    variant="h6"
                    gutterBottom
                    style={{ marginLeft: "20px", marginTop: '10px' }}
                  >
                    Instance Details
                    <Divider />
                  </Typography>
                  <TextField
                    fullWidth
                    name={`trainee_name`}
                    id={`trainee_name`}
                    onChange={handleChange}
                    required
                    select
                    SelectProps={{
                      native: true,
                      style: {
                        color: '#000000',
                        height: '30px'
                      },
                    }}
                    autoComplete="name"
                    value={value}
                    sx={{ width: '400px' }}
                    style={{ color: '#ffffff', marginLeft: '20px', marginTop: '10px' }}
                  >
                    <option value="" style={{ color: '#000000' }}>Select the Trainee</option>
                    {instancelist.Instance_info.map((instance_info, i) => (
                      <option key={i} value={i} {...a11yProps(i)} style={{ color: '#000000' }}>
                        {instance_info.name}
                      </option>
                    ))}
                  </TextField>
                  <PerfectScrollbar>
                    <Card>
                      <CardContent>
                        {instancelist.Instance_info.map((instance_info, i) => {
                          const traineeid = i + 1;
                          return (
                            <React.Fragment>
                              <TabPanel value={value} index={i}>
                                <Grid
                                  container
                                  spacing={1}
                                  marginTop={-5}
                                  marginBottom={-0.5}
                                  marginLeft={0}
                                >
                                  <Grid item xs={12} marginLeft={0}>
                                    <Typography
                                      style={{ display: "inline-block" }}
                                      gutterBottom
                                    >
                                      Assigned user :
                                    </Typography>
                                    <Typography
                                      fontWeight={500}
                                      // marginLeft={1}
                                      style={{ display: "inline-block" }}
                                      gutterBottom
                                    >
                                      {instance_info.email}
                                    </Typography>
                                  </Grid>

                                </Grid>
                                <TableContainer component={Paper}>
                                  <Table
                                    size="small"
                                    // style={{ width: 1215 }}
                                    aria-label="a dense table"
                                  >
                                    <TableHead
                                      style={{ backgroundColor: "#06396c", }}
                                    >
                                      <TableRow sx={{ height: '30px' }}>
                                        <TableCell />
                                        <TableCell
                                          style={{ color: "#ffffff" }}
                                          align="left"
                                        >
                                          Name
                                        </TableCell>
                                        <TableCell
                                          style={{ color: "#ffffff" }}
                                          align="left"
                                        >
                                          Status
                                        </TableCell>
                                        <TableCell
                                          style={{ color: "#ffffff", paddingRight: '10px' }}
                                          align="left"
                                        >
                                          Console Panel
                                        </TableCell>
                                      </TableRow>
                                    </TableHead>
                                    <TableBody>
                                      {instance_info.details.map((details) => (
                                        <React.Fragment key={details.name}>
                                          <TableRow>
                                            <TableCell>
                                              <IconButton
                                                size="small"
                                                onClick={() => handleExpandRow(details.name)}
                                              >
                                                {expandedRow === details.name ? (
                                                  <KeyboardArrowUp />
                                                ) : (
                                                  <KeyboardArrowDown />
                                                )}
                                              </IconButton>
                                            </TableCell>
                                            <TableCell style={{ paddingLeft: '10px' }} align="left">{details.name}</TableCell>
                                            <TableCell style={{ paddingLeft: '5px' }} align="left">
                                              {details.status === "Creating" ||
                                                details.status === "creating" ? (
                                                <Typography
                                                  variant="h6"
                                                  marginLeft={2}
                                                  fontWeight="fontWeightBold"
                                                  style={{
                                                    display: "inline-block",
                                                    color: "#2234E8",
                                                  }}
                                                  // // marginLeft={1}
                                                  gutterBottom
                                                >
                                                  {details.status}
                                                </Typography>
                                              ) : details.status ===
                                                "Running" ||
                                                details.status === "running" ? (
                                                <Typography
                                                  variant="h6"
                                                  marginLeft={2}
                                                  fontWeight="fontWeightBold"
                                                  style={{
                                                    display: "inline-block",
                                                    color: "#209508",
                                                  }}
                                                  // // marginLeft={1}
                                                  gutterBottom
                                                >
                                                  {details.status}
                                                </Typography>
                                              ) : details.status === "Stopped" || details.status === "stopped" ? (
                                                <Typography
                                                  variant="h6"
                                                  marginLeft={2}
                                                  fontWeight="fontWeightBold"
                                                  style={{
                                                    display: "inline-block",
                                                    color: "#F3AF05",
                                                  }}
                                                  // // marginLeft={1}
                                                  gutterBottom
                                                >
                                                  {details.status}
                                                </Typography>
                                              ) : details.status === "Starting" || details.status === "starting" ? (
                                                <Typography
                                                  variant="h6"
                                                  marginLeft={2}
                                                  fontWeight="fontWeightBold"
                                                  style={{
                                                    display: "inline-block",
                                                    color: "#F3AF05",
                                                  }}
                                                  // // marginLeft={1}
                                                  gutterBottom
                                                >
                                                  {details.status}
                                                </Typography>
                                              ) : details.status === "Stopping" || details.status === "stopping" ? (
                                                <Typography
                                                  variant="h6"
                                                  marginLeft={2}
                                                  fontWeight="fontWeightBold"
                                                  style={{
                                                    display: "inline-block",
                                                    color: "#F3AF05",
                                                  }}
                                                  // // marginLeft={1}
                                                  gutterBottom
                                                >
                                                  {details.status}
                                                </Typography>
                                              ) : details.status === "Start Initiated" || details.status === "start initiated" ? (
                                                <Typography
                                                  variant="h6"
                                                  marginLeft={2}
                                                  fontWeight="fontWeightBold"
                                                  style={{
                                                    display: "inline-block",
                                                    color: "#F3AF05",
                                                  }}
                                                  // // marginLeft={1}
                                                  gutterBottom
                                                >
                                                  {details.status}
                                                </Typography>
                                              ) : details.status === "Cordoned" || details.status === "cordoned" ? (
                                                <Typography
                                                  variant="h6"
                                                  marginLeft={2}
                                                  fontWeight="fontWeightBold"
                                                  style={{
                                                    display: "inline-block",
                                                    color: "#848884",
                                                  }}
                                                  // // marginLeft={1}
                                                  gutterBottom
                                                >
                                                  {details.status}
                                                </Typography>
                                              ) : details.status === "Stop Initiated" || details.status === "stop initiated" ? (
                                                <Typography
                                                  variant="h6"
                                                  marginLeft={2}
                                                  fontWeight="fontWeightBold"
                                                  style={{
                                                    display: "inline-block",
                                                    color: "#F3AF05",
                                                  }}
                                                  // // marginLeft={1}
                                                  gutterBottom
                                                >
                                                  {details.status}
                                                </Typography>
                                              ) : details.status === "Failed_Create" || details.status === "failed_create" ? (
                                                <Typography
                                                  variant="h6"
                                                  marginLeft={2}
                                                  fontWeight="fontWeightBold"
                                                  style={{
                                                    display: "inline-block",
                                                    color: "#D73206",
                                                  }}
                                                  // // marginLeft={1}
                                                  gutterBottom
                                                >
                                                  {details.status}
                                                </Typography>
                                              ) : details.status === "Failed_Con_Create" || details.status === "failed_con_create" ? (
                                                <Typography
                                                  variant="h6"
                                                  marginLeft={2}
                                                  fontWeight="fontWeightBold"
                                                  style={{
                                                    display: "inline-block",
                                                    color: "#D73206",
                                                  }}
                                                  // // marginLeft={1}
                                                  gutterBottom
                                                >
                                                  {details.status}
                                                </Typography>
                                              ) : details.status === "Failed_Stop" || details.status === "failed_stop" ? (
                                                <Typography
                                                  variant="h6"
                                                  marginLeft={2}
                                                  fontWeight="fontWeightBold"
                                                  style={{
                                                    display: "inline-block",
                                                    color: "#D73206",
                                                  }}
                                                  // // marginLeft={1}
                                                  gutterBottom
                                                >
                                                  {details.status}
                                                </Typography>
                                              ) : details.status === "Failed_Start" || details.status === "failed_start" ? (
                                                <Typography
                                                  variant="h6"
                                                  marginLeft={2}
                                                  fontWeight="fontWeightBold"
                                                  style={{
                                                    display: "inline-block",
                                                    color: "#D73206",
                                                  }}
                                                  // // marginLeft={1}
                                                  gutterBottom
                                                >
                                                  {details.status}
                                                </Typography>
                                              ) : details.status === "Failed_Con_Update" || details.status === "failed_con_update" ? (
                                                <Typography
                                                  variant="h6"
                                                  marginLeft={2}
                                                  fontWeight="fontWeightBold"
                                                  style={{
                                                    display: "inline-block",
                                                    color: "#D73206",
                                                  }}
                                                  // // marginLeft={1}
                                                  gutterBottom
                                                >
                                                  {details.status}
                                                </Typography>
                                              ) : details.status === "Failed_Cordon" || details.status === "failed_cordon" ? (
                                                <Typography
                                                  variant="h6"
                                                  marginLeft={2}
                                                  fontWeight="fontWeightBold"
                                                  style={{
                                                    display: "inline-block",
                                                    color: "#D73206",
                                                  }}
                                                  // // marginLeft={1}
                                                  gutterBottom
                                                >
                                                  {details.status}
                                                </Typography>
                                              ) : details.status === "failed_add" ? (
                                                <Typography
                                                  variant="h6"
                                                  marginLeft={2}
                                                  fontWeight="fontWeightBold"
                                                  style={{
                                                    display: "inline-block",
                                                    color: "#D73206",
                                                  }}
                                                  // // marginLeft={1}
                                                  gutterBottom
                                                >
                                                  {details.status}
                                                </Typography>
                                              ) : details.status === "failed_remove" ? (
                                                <Typography
                                                  variant="h6"
                                                  marginLeft={2}
                                                  fontWeight="fontWeightBold"
                                                  style={{
                                                    display: "inline-block",
                                                    color: "#D73206",
                                                  }}
                                                  // // marginLeft={1}
                                                  gutterBottom
                                                >
                                                  {details.status}
                                                </Typography>
                                              ) : details.status === "failed_add_con_create" ? (
                                                <Typography
                                                  variant="h6"
                                                  marginLeft={2}
                                                  fontWeight="fontWeightBold"
                                                  style={{
                                                    display: "inline-block",
                                                    color: "#D73206",
                                                  }}
                                                  // // marginLeft={1}
                                                  gutterBottom
                                                >
                                                  {details.status}
                                                </Typography>
                                              ) : details.status === "Deleted" || details.status === "deleted" || details.status === "delete initiated" || details.status === "deleting" ? (
                                                <Typography
                                                  variant="h6"
                                                  marginLeft={2}
                                                  fontWeight="fontWeightBold"
                                                  style={{
                                                    display: "inline-block",
                                                    color: "#D73206",
                                                  }}
                                                  // marginLeft={1}
                                                  gutterBottom
                                                >
                                                  {details.status}
                                                </Typography>
                                              ) : details.status === "failed_trainee_delete" ? (
                                                <Typography
                                                  variant="h6"
                                                  marginLeft={2}
                                                  fontWeight="fontWeightBold"
                                                  style={{
                                                    display: "inline-block",
                                                    color: "#D73206",
                                                  }}
                                                  // marginLeft={1}
                                                  gutterBottom
                                                >
                                                  {details.status}
                                                </Typography>
                                              ) : (
                                                "NA"
                                              )}
                                            </TableCell>
                                            <TableCell align="left" colSpan={3}>
                                              <Tooltip title="Connect" arrow>
                                                <span>
                                                  <Button
                                                    size="small"
                                                    variant="contained"
                                                    target="_blank"
                                                    endIcon={<OpenInNewIcon style={{ height: "15px" }} />}
                                                    href={details.connection_url}
                                                    // onClick={() => handleConnectClick(details)}
                                                    style={{ height: "25px" }}
                                                    disabled={(details.status === "running" || details.status === "Running") ? false : true}
                                                  >
                                                    Connect
                                                  </Button>
                                                </span>
                                              </Tooltip>
                                            </TableCell>
                                          </TableRow>
                                          <TableRow>
                                            <TableCell
                                              style={{ paddingBottom: 0, paddingTop: 0 }}
                                              colSpan={4}
                                            >
                                              <Collapse
                                                in={expandedRow === details.name}
                                                timeout="auto"
                                                unmountOnExit
                                              >
                                                <Box sx={{ p: 1 }}>
                                                  {/* Responsive Grid layout for expanded content */}
                                                  <Grid container spacing={0.5}>
                                                    <Grid item xs={12} sm={6} md={4}>
                                                      <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
                                                        <Typography variant="body2" fontWeight="bold" color="text.primary" sx={{ minWidth: '140px' }}>
                                                          Instance Public IP:
                                                        </Typography>
                                                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                                                          <Typography variant="body2">{details.public_ip_address || 'NA'}</Typography>
                                                          {details.public_ip_address && (
                                                            <CopyToClipboard text={details.public_ip_address} onCopy={() => setCopied(true)}>
                                                              <IconButton size="small" color="primary" onClick={handleClick}>
                                                                <FileCopyOutlinedIcon style={{ fontSize: '18px' }} />
                                                              </IconButton>
                                                            </CopyToClipboard>
                                                          )}
                                                        </Box>
                                                      </Box>
                                                    </Grid>
                                                    <Grid item xs={12} sm={6} md={4}>
                                                      <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
                                                        <Typography variant="body2" fontWeight="bold" color="text.primary" sx={{ minWidth: '130px' }}>
                                                          Instance Username:
                                                        </Typography>
                                                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                                                          <Typography variant="body2">{details.instance_username}</Typography>
                                                          <CopyToClipboard text={details.instance_username} onCopy={() => setCopied(true)}>
                                                            <IconButton size="small" color="primary" onClick={handleClick}>
                                                              <FileCopyOutlinedIcon style={{ fontSize: '18px' }} />
                                                            </IconButton>
                                                          </CopyToClipboard>
                                                        </Box>
                                                      </Box>
                                                    </Grid>
                                                    <Grid item xs={12} sm={6} md={4}>
                                                      <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
                                                        <Typography variant="body2" fontWeight="bold" color="text.primary" sx={{ minWidth: '130px' }}>
                                                          Instance Password:
                                                        </Typography>
                                                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                                                          {showInstancePassword ? (
                                                            <Typography variant="body2">{details.instance_password}</Typography>
                                                          ) : (
                                                            <Typography variant="body2">******</Typography>
                                                          )}
                                                          <IconButton size="small" color="primary" onClick={handleInstancePasswordIconClick}>
                                                            {showInstancePassword ? <VisibilityOffIcon style={{ fontSize: '18px' }} /> : <VisibilityIcon style={{ fontSize: '18px' }} />}
                                                          </IconButton>
                                                          <CopyToClipboard text={details.instance_password} onCopy={() => setCopied(true)}>
                                                            <IconButton size="small" color="primary" onClick={handleClick}>
                                                              <FileCopyOutlinedIcon style={{ fontSize: '18px' }} />
                                                            </IconButton>
                                                          </CopyToClipboard>
                                                        </Box>
                                                      </Box>
                                                    </Grid>

                                                    <Grid item xs={12}><Divider sx={{ my: 0 }} /></Grid>

                                                    <Grid item xs={12} sm={6} md={4}>
                                                      <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
                                                        <Typography variant="body2" fontWeight="bold" color="text.primary" sx={{ minWidth: '80px' }}>
                                                          OS Type:
                                                        </Typography>
                                                        <Typography variant="body2">{details.ostype}</Typography>
                                                      </Box>
                                                    </Grid>
                                                    <Grid item xs={12} sm={6} md={4}>
                                                      <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
                                                        <Typography variant="body2" fontWeight="bold" color="text.primary" sx={{ minWidth: '100px' }}>
                                                          Open Ports:
                                                        </Typography>
                                                        <Typography variant="body2">{details.port}</Typography>
                                                      </Box>
                                                    </Grid>

                                                    <Grid item xs={12}><Divider sx={{ my: 0 }} /></Grid>

                                                    <Grid item xs={12} sm={6} md={4}>
                                                      <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
                                                        <Typography variant="body2" fontWeight="bold" color="text.primary" sx={{ minWidth: '110px' }}>
                                                          Usage Report:
                                                        </Typography>
                                                        <ActiveLog name={details.name} index_name={details.tag} analytics_panel_id={details.analytics_panel_id} />
                                                      </Box>
                                                    </Grid>
                                                    <Grid item xs={12} sm={6} md={4}>
                                                      <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
                                                        <Typography variant="body2" fontWeight="bold" color="text.primary" sx={{ minWidth: '110px' }}>
                                                          Activity Log:
                                                        </Typography>
                                                        <Log LabID={localStorage.getItem('InstanceID')} InstanceID={details.instance_id} />
                                                      </Box>
                                                    </Grid>
                                                  </Grid>
                                                </Box>
                                              </Collapse>
                                            </TableCell>
                                          </TableRow>
                                        </React.Fragment>
                                      ))}
                                    </TableBody>
                                  </Table>
                                </TableContainer>
                              </TabPanel>
                            </React.Fragment>
                          );
                        })}
                      </CardContent>
                    </Card>
                  </PerfectScrollbar>
                </Card>
              </Box>
            </Container>
          </Box>
        </React.Fragment>
      ))}
    </>
  );
};

export default ManualDetails;
